// extracted by mini-css-extract-plugin
module.exports = {"container":"Price_container__rZ6gu","item":"Price_item__1iRux","price":"Price_price__qNPhP","date":"Price_date__3PHtx"};